import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./base.service";
import { IBusinessFunction } from "../interfaces/ibusinessfunction";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

/**
 * @WhatItDoes A service to cater the requirement on admin home page.
 *
 * @HowToUseIt Inject the service
 */
@Injectable()
export class BusinessFunctionService extends BaseService {

   /**
    * Constructor for service
    * @param httpClient angular http module
    * @param toastr toastr manager
    * @param store store
    */
    constructor(httpClient: HttpClient, toastr: ToastrService, store: Store<IAppStore>) {
        super(httpClient, toastr, store);
    }

    /**
     * Returns all business functions
     */
    getAll(): Observable<IBusinessFunction[]> {
        return super.get(`/api/businessfunction`).pipe(
            map((res: any) => res)
        );
    }

    /**
     * Returns a business function
     */
    getBusinessFunction(businessFunctionId: number): Observable<IBusinessFunction> {
        return super.get(`/api/businessfunction/${businessFunctionId}`).pipe(
            map((res: any) => res as IBusinessFunction)
        );
    }

    /**
     * Returns an observable of the updated business function
     * @param businessfunction The business function to update
     */
    update(businessfunction: IBusinessFunction): Observable<IBusinessFunction> {
        return super.put("/api/businessfunction", businessfunction).pipe(
            map((res: any) => res as IBusinessFunction)
        );
    }

    /**
     * Returns an observable of last updated date
     * @param businessFunctionId A businessFunction Id to get the last updated date.
     */
    getLastUdpatedDate(): Observable<Date> {
        return super.get(`/api/contentlatestupdate`).pipe(
            map((res: any) => res as Date)
        );
    }

    /**
     * Updates the validation date for a given businessfunction
     * Returns an observable of home
     * @param businessFunctionData A business Function data populated with new date to be updated as new validation date.
     */
    updateValidationDate(): Observable<IBusinessFunction> {
        return super.put("/api/contentlatestupdate", {}).pipe(
            map((res: any) => res as IBusinessFunction)
        );
    }

    /**
     * Creates a new business function
     * @param businessfunction The business function to be created
     */
    create(businessFunction: IBusinessFunction): Observable<number> {
        return super.post("/api/businessfunction", businessFunction).pipe(
            map((res: any) => res as number)
        );
    }

    getImage(id: number): Observable<string> {
        return super.getText(`/api/businessfunction/getImage/${id}`);
    }   
}




